var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.$route.meta.auth === false)?_c('router-view'):_vm._e(),_c('div',{staticClass:"main-outer-blk"},[(_vm.$route.meta.auth === true)?_c('router-view'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }